<template>
  <dx-modal :value="show" :title="title" size="md" @input="close()" id="modal-cash-register-reason">
    <div class="columns">
      <div class="column col-12 form-group" v-if="message">
        <div class="toast toast-warning">{{ message }}</div>
      </div>
      <div class="column col-12 form-group" :class="{'has-error': $v.form.reason.$error}">
        <label class="form-label">{{ label }}</label>
        <textarea class="form-input"
                  v-model="form.reason"
                  rows="3"
                  @blur="$v.form.reason.$touch()"></textarea>
        <template v-if="$v.form.reason.$error">
          <div class="form-input-hint">Campo obrigatório</div>
        </template>
      </div>
    </div>
    <template slot="footer">
      <button class="btn btn-primary mr-1"
              :class="{loading: saving}"
              :disabled="saving"
              @click="confirm">
        {{ confirmLabel }}
      </button>
      <button class="btn" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Motivo',
    },
    label: {
      type: String,
      default: 'Motivo',
    },
    message: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: 'Confirmar',
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        reason: '',
      },
    };
  },
  validations: {
    form: {
      reason: { required },
    },
  },
  methods: {
    confirm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      this.$emit('confirm', this.form.reason);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
